import React from 'react';
import { ResponsiveImage } from '../ResponsiveImage';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const ArticleCard = ({ article, section, context = 'list' }) => {
  const id = `${context}-${section}-${article.slug}`;
  return (
    <Link to={`/conseils-${section}/${article.slug}`} data-testid={`${id}-link`}
      className="group min-w-0 bg-white rounded-lg overflow-hidden border border-gray-100 hover:shadow-lg transition-shadow focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#E30022]">
      <div className="aspect-video overflow-hidden">
        <ResponsiveImage src={article.image} sizes="(min-width: 1280px) 384px, (min-width: 1024px) 33vw, (min-width: 768px) 50vw, 100vw" alt={article.title} data-testid={`${id}-image`}
          className="w-full h-full object-contain group-hover:scale-[1.02] transition-transform duration-500" />
      </div>
      <div className="p-5 sm:p-6">
        <span data-testid={`${id}-category`} className="text-xs text-[#E30022] font-medium">{article.category}</span>
        <h3 data-testid={`${id}-title`} className="text-base md:text-lg font-semibold text-gray-800 my-3 group-hover:text-[#E30022] transition-colors">{article.title}</h3>
        <p data-testid={`${id}-excerpt`} className="text-gray-600 text-sm mb-4 line-clamp-2">{article.excerpt}</p>
        <div className="flex flex-wrap justify-between items-center gap-3 text-sm">
          <span data-testid={`${id}-read-time`} className="text-gray-500">{article.readTime} de lecture</span>
          <span className="text-[#E30022] font-medium inline-flex items-center gap-1">Lire <ArrowRight aria-hidden="true" className="h-4 w-4" /></span>
        </div>
      </div>
    </Link>
  );
};